import React, { forwardRef, useContext, useId } from 'react'

import { RadioGroupContext } from './RadioGroup'
import { RadioInput } from './RadioInput'

export interface RadioButtonTypes extends Omit<React.InputHTMLAttributes<HTMLInputElement>, 'className'> {
  description?: React.ReactNode;
  disabled?: boolean;
  label?: React.ReactNode;
  name?: string;
}

export const RadioButton = forwardRef<HTMLInputElement, RadioButtonTypes>(({ description, id, label, name, ...props }, forwardedRef) => {
  const autogeneratedId = useId()
  const descriptionId = useId()
  const inputId = id || autogeneratedId

  const { name: radioGroupName } = useContext(RadioGroupContext)
  const appliedName = radioGroupName ?? name

  return (
    <div className='group inline-flex items-baseline'>
      <RadioInput
        {...props}
        aria-describedby={description ? descriptionId : undefined}
        id={inputId}
        name={appliedName}
        ref={forwardedRef}
      />
      {!!label && (
        <div className='space-y-1 relative -top-[0.0625rem]'>
          <label
            className='pl-3 block body text-gray-800 group-has-[:disabled]:text-gray-500'
            htmlFor={inputId}
          >
            {label}
          </label>
          {!!description && (
            <p className='pl-3 text-gray-500 body-sm' id={descriptionId}>
              {description}
            </p>
          )}
        </div>
      )}
    </div>
  )
})
